var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerson = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "person-a",
    d: "M35.9230769,28 C33,28 30.3846154,26.9305556 28.2307692,24.7916667 C26.0769231,22.6527778 25,20.0555556 25,17 C25,13.9444444 26.0769231,11.5 28.0769231,9.20833333 C30.2307692,7.06944444 32.8461538,6 35.9230769,6 C39,6 41.6153846,7.06944444 43.7692308,9.20833333 C45.9230769,11.3472222 47,13.9444444 47,17 C47,20.0555556 45.9230769,22.6527778 43.7692308,24.7916667 C41.6153846,26.9305556 39,28 35.9230769,28 Z M27.5290807,32.8491306 C29.7354597,35.1432731 32.4146341,36.2903443 35.4090056,36.2903443 C38.5609756,36.2903443 41.2401501,35.1432731 43.4465291,32.8491306 C43.711905,32.5731988 43.9613216,32.2901553 44.194779,32 L46.7560976,32 C52.4136487,32 57,36.8021314 57,42.7258607 L57,58.8146517 C50.747518,63.6048839 43.373759,66 36,66 C28.626241,66 21.252482,63.6048839 15,58.8146517 L15,42.7258607 C15,36.8021314 19.5863513,32 25.2439024,32 L26.7808308,32 C27.0142881,32.2901553 27.2637048,32.5731988 27.5290807,32.8491306 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#person-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person.fbf73ab9264435bbdf7279799f8fbeae.svg";